import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20warm%20orange%20and%20coral%20gradient%20background%20with%20soft%20flowing%20wave%20patterns%20minimal%20modern%20design%20subtle%20texture%20elegant%20atmosphere%20digital%20art%20style%20clean%20and%20sophisticated&width=1800&height=900&seq=hero-bg-hanhan&orientation=landscape"
          alt="汗汗漫画 - 背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 leading-tight">
          汗汗漫画
        </h1>
        <p className="text-lg md:text-2xl text-background-100/90 mb-3 font-semibold">
          下拉式漫画连续阅读，滚动观看不间断
        </p>
        <p className="text-sm md:text-base text-background-200/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          漫画下拉即可加载全集，免费流畅观看各类漫画，感受全新阅读方式
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/rexue"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始阅读
            <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center"></i>
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading text-background-50">1200+</p>
            <p className="text-xs text-background-300 mt-1">漫画作品</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading text-background-50">500万+</p>
            <p className="text-xs text-background-300 mt-1">累计读者</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading text-background-50">99.7%</p>
            <p className="text-xs text-background-300 mt-1">好评率</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl w-6 h-6 flex items-center justify-center"></i>
      </div>
    </section>
  );
}